import React from 'react';
import {Container,Button, Form, FormGroup, Label, Input, Row, Col , Modal, ModalBody,  } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import httpClient from '../../httpClient';
import {
faPlus,
faUserCircle,
faPen,
faTrashAlt,
faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router-dom";
import PagePath from '../../components/common/pagePath'
import DashInputs from '../../components/Admin/dashInputs';
import ReserveBtn from '../../components/common/Vols/reserveBtn'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { purple ,red,green} from '@mui/material/colors';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import DashTab from '../../components/Admin/dashTab';
import { connect } from 'react-redux';


const theme = createMuiTheme({
  palette: {
    primary: purple,
    secondary: red,
  },
 
});

class Profile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      myId:this.props.match.params.id,
      profile : {},
      hebAnnounces : [],
      carAnnounces :[]

    };
    this.toggleSignup = this.toggleSignup.bind(this);
    // this.sousAgentItirator = this.sousAgentItirator.bind(this);
    // this.sousAgentItirator();
  }
   handleTab = (event, newValue) => {
    this.setState({tabValue : newValue});
  };
  // componentDidUpdate() {
  //   this.sousAgentItirator();
  // }

  async componentDidMount(){
    let profile = await httpClient.getUser(this.state.myId)
    let hebAnnounces = await httpClient.getUserAnnounces(this.state.myId,"accommodations")
    let carAnnounces = await httpClient.getUserAnnounces(this.state.myId,"cars")
    this.setState({
      profile : profile,
      hebAnnounces : hebAnnounces,
      carAnnounces :carAnnounces
    })
  }

  toggleSignup() {
    this.setState({
      modalSignup: !this.state.modalSignup
    });
  }

  onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
		})
  }
  

  onFormSubmitSignup(evt) {
    evt.preventDefault()
		httpClient.signUp(this.state.fields).then(user => {
			this.setState({ fields: { name: '', email: '', password: ''} })
			if(user) {
				this.props.onSignUpSuccess(user)
        this.setState({
          modalSignup:false
        });			}
        return 
    })
	}
  
  // sousAgentItirator(){
  //   httpClient.getAgentsList().then(res=>{
  //     this.setState({
  //       sousAgentList: res,
  //     });
  //   }
  //   )
  // }
  // DesactiverSousAgent(evt){
  //   httpClient.ActiveInactive(evt.target.checked,evt.target.id);
  // }

	render() {
    const profile = this.state.profile;
    const hebrg = this.state.hebAnnounces
    const cars = this.state.carAnnounces
    const items = ["HÉBERGEMENT", "VOLS", "VISAS", "VOYAGES","VÉHICULES", "DIVERTISSEMENTS", "TOUTES"];
    const HOST_NAME = process.env.REACT_APP_SERVER_URL

		return (
            <>
            <Container>
              <PagePath pages={['Acceuil', 'Profil']}/>

              <div className="profile__head d-flex mt-5">
                <div className="col-2">
                  <img src="/imgs/profile/avatar.svg" alt="" width="150px" />
                </div>
                <div className="col-6 d-flex justify-content-between">
                  <div>
                    <div className="prof__infos">
                      <h2 className='prof__head__txt prof__name'>{profile.name}</h2>
                      <div className="prof__personnel mt-3">
                        <div className="d-flex align-items-center mb-2">
                          <img src="/imgs/profile/msg.svg" className='mr-2 infos__icons' alt="" />
                          <h6 className='prof__head__txt mt-2'>{profile.email}</h6>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <img src="/imgs/profile/call.svg" className='mr-2 infos__icons' alt="" />
                          <h6 className='prof__head__txt mt-2'>+{profile.phone||"+21790122263"}</h6>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <img src="/imgs/profile/phone.svg" className='mr-2 infos__icons' alt="" />
                          <h6 className='prof__head__txt mt-2'>{profile.phone2||"+21790122263"}</h6>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <img src="/imgs/profile/local.svg" className='mr-2 infos__icons' alt="" />
                          <h6 className='prof__head__txt mt-2'>Bvd Houari Boumedien, Skikda</h6>
                        </div>
                      </div>
                      <div className="prf__btns d-flex mt-3 align-items-center">
                        <Button className='flw__btn mr-2'>
                          <span>Abonner</span>
                          <img src="/imgs/profile/follow.svg" className='flw__icons' alt="" />
                        </Button>
                        <Button className='msg__btn mr-2'>
                          <span>Message</span>
                          <img src="/imgs/profile/send.svg" className='flw__icons' alt="" />
                        </Button>
                        <div >
                        <a href="#"  id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                          <img className='points__btn'  src="/imgs/profile/points.svg" alt="" />
                          </a>
                          <div class="dropdown-menu mt-3" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item d-flex align-items-center" href="#">Signaler<span><img src="/imgs/profile/signal.svg" className='flw__icons ml-2' alt="" /></span></a>
                            <a class="dropdown-item d-flex align-items-center" href="#">Partager<span><img src="/imgs/profile/share.svg" className='flw__icons ml-2' alt="" /></span></a>
                          </div>
                        </div>
                       
                      </div>
                      
                    </div>
                  </div>
                  <div className="d-flex">
                    <h6 className='prof__bdg mr-2 d-flex align-items-center'><span>Verifié</span><img className='bdg__icons ml-2' src="/imgs/profile/check.svg" alt="" /></h6>
                    <h6 className='prof__bdg d-flex align-items-center'><img src="/imgs/profile/star.svg" className='bdg__icons mr-2' alt="" /><span>4.8/5</span></h6>
                  </div>
                </div>
                <div className="col-4">
                <img src="/imgs/profile/map.png" alt="" width="350px" />
                </div>
              </div>
              <hr className='mt-5' style={{height:"2px", border:"none" ,color: "#e5e5e5",backgroundColor:"#e5e5e5" }}/>
              <div className="prof__annouces mt-4">
              {(hebrg.length >0 ||  cars.length>0) &&<DashTab items={items} nested={true} content={[this.state.hebAnnounces,[],[],[],this.state.carAnnounces]}/>}
              </div>
              {/* <div className="container d-flex justify-content-between profile__header">
                <div className="col-6 pl-0">
                 <div className="profile__infos d-flex align-items-center">
                      <img src="/imgs/dash/profile.svg" className='profile__icon' alt="" />
                      <h3 className='profile__name'>Faiçal Ski21</h3>
                      <h6 className='profile__bdg bdgs mr-2'>Membre Gold</h6>
                      <h6 className='profile__rating bdgs d-flex align-items-center'><img className='rating__star' src="/imgs/dash/star.svg" alt="" srcset="" /><span>4.8/5</span></h6>
                  </div>
                  <h6 className='ml-1 mt-2 addAnn__txt'>Modifier <FontAwesomeIcon icon={faEdit}/></h6>
                  <div className="infos__inputs__container mt-4">
                    <DashInputs label="Nom" type="text" pHolder="Nom" />
                    <DashInputs label="Prénom" type="text" pHolder="Prénom" />
                    <DashInputs label="E-mail" type="email" pHolder="Email" />
                    <DashInputs label="Mot de passe" type="password" pHolder="Mot de passe" />
                    <DashInputs label="Téléphone" type="phone" pHolder="07777777" />
                    <DashInputs label="Adresse" type="Text" pHolder="Cite 41 RN Skikda" />
                    <DashInputs label="Fax" type="Text" pHolder="02111111" />
                    <DashInputs label="Site web" type="Text" pHolder="www.exemple.com" />
                  </div>
                </div>
                <div className="col-6 pr-0">
                  <div className="d-flex justify-content-end">
                    <div className="newAnn d-flex flex-column  align-items-center ">
                      <img src="/imgs/dash/add__fill.svg" className='addAnn__fill mb-2' alt="" />
                      <h6 className='addAnn__txt'>Nouvelle<br/> Annonce</h6>
                    </div>
                  </div>
                    <div className="profile__personnel d-flex flex-column  px-3 py-3 mb-2">
                        <h3>Faical Laroum</h3>
                        <span>ID Nombre : 000111222333</span>
                        <span>Permis C : 000000/21  -  Délivrée le 11/11/2011</span>
                        <span>Adresse : Bvd. Houari Boumedien. Bt 10. n°6. Skikda 21000</span>
                    </div>
                    <button className='dmnd__btn mb-3'>Demander une rectification / Modification</button>
                    <h4 className='bdg__txt'>Badges</h4>
                    <div className="bdg__container d-flex flex-row flex-wrap">
                    <span className='profile__badges mr-2'>Hébergeur Vérifié</span>
                      <span className='profile__badges mr-2'>ID Verifiée</span>
                      <span className='profile__badges mr-2'>Guide Agréé</span>
                      <span className='profile__badges mr-2'>Responsive</span>
                      <span className='profile__badges mr-2'>Responsive</span>
                      <span className='profile__badges mr-2'>ID Verifiée</span>
                      <span className='profile__badges mr-2'>Guide Agréé</span>
                    </div>
                  </div>
                  
              </div> */}
            {/* <Row></Row>
             <div className="path">
               Admin/Progile
             </div>
             <Row>
                 <Col xs="6" className="form-left">
                   <Row>
                   <Col xs="12" style={{position:"relative"}}>
                 <div className="circle-profile">
                  <span  type="button"><span className="text-Pro">
                   <FontAwesomeIcon className="icon" icon={faUserCircle} />
                   </span></span>
                   <div className="circle-title">Modifier</div>
                  </div>
                  <div className="head-circle">
                  <h2 className="myAgenceName">L&B Voyages</h2>
                  <h5 className="myName">Imad Eddine Mansour</h5>
                  </div>
                  </Col>
                   </Row>

                 <Form>
                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile" style={{margin:"0"}}>E-mail</Label>
                    <Input className="input-profile" type="email" name="email" id="exampleEmail" placeholder="exemple@gmail.com"  />
                  </FormGroup>

                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile">Mot de Passe</Label>
                    <Input className="input-profile" type="password" name="password" id="examplePassword" placeholder="Ss213254" />
                  </FormGroup>

                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile">Adress</Label>
                    <Input className="input-profile" type="textarea" name="text" id="exampleText" placeholder="LSP Bloc A 23 Briones"/>
                  </FormGroup>

                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile">Phone</Label>
                    <Input className="input-profile" type="email" name="email" id="exampleEmail" placeholder="+21379112224" />
                  </FormGroup>

                  <FormGroup >
                  <Label for="exampleSelect" className="label-profile">Fax</Label>
                    <Input className="input-profile" type="email"  name="email" id="exampleEmail" placeholder="1324Az235" />
                  </FormGroup>

                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile">Site Web</Label>
                    <Input className="input-profile" type="email" name="email" id="exampleEmail" placeholder="https://www.exemple.com" />
                  </FormGroup>
                  <FormGroup>
                  <Label for="exampleSelect" className="label-profile">Description</Label>
                    <Input className="input-profile" type="textarea" name="text" placeholder="Description" />
                  </FormGroup>
                  <Button   onSubmit={this.sousAgentItirator.bind(this)}>Valider</Button>
              </Form>
              </Col>
              <Col xs="6" className="infos-right">
                <Container>
                <Row>
                 <Col xs="12" >
                   <div className="circle-profile" style={{float:"right"}}>
                     <span  type="button"><span className="text-Pro">
                      <FontAwesomeIcon className="icon" icon={faPlus} />
                      </span></span>
                      <div className="circle-title">Nouvelle Annonces</div>
                   </div>
                   <div className="head-circle"></div>
                  </Col>
                </Row>

               <Col sx="12">
                 <Row>
                 <div className="reference">
                   <Row>
                     <div className="text-reference">
                     <Col sx="4">
                       <span className="block-display">
                         R/C
                       <span className="number">
                         000000000000000000
                       </span>
                       </span>

                       <span className="block-display">
                         N/F
                       <span className="number">
                         111111111111112222
                       </span>
                       </span>

                       <span className="block-display">
                         N/S
                       <span className="number">
                         151515151515151515
                       </span>
                       </span>

                       <span className="block-display">
                         Agrément
                       <span className="number">
                         15/10/2020 N1 0653
                       </span>
                       </span>

                     </Col>
                     </div>
                   </Row>
                 </div>

                 <Button className="button-underdiv" >Demander une rectification /Modifications</Button>
                 </Row>
               </Col>
               <Col sx="12">
                 <Row>
                   <span className="title-block">Sous-agent</span>
                   <div className="sous-agent">
                     <Row>
                       <Col xs="12">
                       <div>
                   
                         { 
                          list &&
                            this.state.sousAgentList.map(function (feature, i) {
                              if(feature.sousAgent){
                                return(   
                                  <div class="sous-agent-line" key={feature.Id}>
                                  <span className="sous-agent-nom">{feature.name}</span>
                                  <div className="edit-delete-sa">
                                  <input type="checkbox" hidden="hidden" value={feature._id} id={feature.name} defaultChecked={feature.sousAgentAcitveInAcitve&&"true"}
                                  onClick={(evt=>{
                                    httpClient.ActiveInactive(evt.target.checked,evt.target.value);
                                  })}
                                  />
                                   <label class="switch" for={feature.name}></label>
                                  <FontAwesomeIcon className="icon-small" icon={faPen} title="Edit"/>
                                  <FontAwesomeIcon className="icon-small"name={feature._id} id={i}  icon={faTrashAlt} title="Delete"
                                          onClick={(evt=>{
                                            var idAgent = document.getElementById(`${i}`).getAttribute("name")
                                            httpClient.DeleteSousAgent(idAgent);
                                          })} 
                                  />
                                  </div>
                                  </div>
                                  )
                              }return ""})
                           }
                       </div>
                       </Col>
                       <Col xs="12">
                       <div class="sous-agent-line">
                             <span className="sous-agent-nom">Imad Mansour</span>
                            <div className="edit-delete-sa">
                                  <input type="checkbox" hidden="hidden" id="imad" onClick={this.DesactiverSousAgent.bind(this)} />
                                   <label class="switch" for="imad"></label>
                                  <FontAwesomeIcon className="icon-small" icon={faPen} title="Edit"/>
                                  <FontAwesomeIcon className="icon-small" icon={faTrashAlt} title="Delete" />
                            </div>
                        </div>
                       </Col>
                     </Row>
                   </div>
                   <Button className="button-underdiv" onClick={this.toggleSignup}>Ajouter</Button>
                 </Row>
               </Col>
               <Col sx="12">
                 <Row>
                   <span className="title-block">Badges</span>
                   <div className="badges">
                   </div>
                 </Row>
               </Col>
               </Container>
              </Col>
             </Row> */}
            </Container>

            <Modal isOpen={this.state.modalSignup} toggle={this.toggleSignup} className={this.props.className}>
          {/* <ModalHeader toggle={this.toggle}>Modal title</ModalHeader> */}
          <img src='imgs/logo/Group_83.svg' alt='logo' className="logo-login-modal"  />
          <ModalBody>
            <Form className="form-login" onChange={this.onInputChange.bind(this)} onSubmit={this.onFormSubmitSignup.bind(this)}>
            <div className="title-center">Veuillez remplir les informations pour le nouveau agent</div>
              <FormGroup>
                <Input type="text" name="name" id="souAgentName" placeholder="Nom de l'agent" className="placeholder-center" ></Input>
              </FormGroup>

              <FormGroup>
                  <Input type="email" className="placeholder-center" name="email" id="examplePassword" placeholder="Adress e-mail" />
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Créer un mot de passe" />
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="retypepassword" id="retypePassword" placeholder="Confirmer votre mot de passe"/>
              </FormGroup>

              <FormGroup>
              <Button className="submit-button" style={{backgroundColor:"#00A706",marginBottom:"17px",borderRadius:"11px"}}>S'inscrire</Button>
              </FormGroup>
            </Form>
            </ModalBody>
          </Modal>
            </>
		)
	}
}


//connect function INJECTS dispatch function as a prop!!
export default withRouter(Profile);

